import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import Moment from 'react-moment';
import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../generics/help';
import LabelForm from '../../components/LabelForm';
import SelectForm from '../../components/SelectForm';
import { clinicHistoryYearsHasHc, donationTypeExtraction, labSectionsByHf, pdfIMSS } from '../../libs/services';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../config');

class STMonthly extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
		this.dateCompare = this.dateCompare.bind(this);

        this.onPrint = this.onPrint.bind(this);

		this.state = {
			health_facilities_id:'',
            year:'',
            init_month:'',
            years:[],
            months:[
                {value:'1', text:'Enero'},
                {value:'2', text:'Febrero'},
                {value:'3', text:'Marzo'},
                {value:'4', text:'Abril'},
                {value:'5', text:'Mayo'},
                {value:'6', text:'Junio'},
                {value:'7', text:'Julio'},
                {value:'8', text:'Agosto'},
                {value:'9', text:'Septiembre'},
                {value:'10', text:'Octubre'},
                {value:'11', text:'Noviembre'},
                {value:'12', text:'Diciembre'},
            ],
			data:[],
            columns:[[
                {title:'No.', rowspan:2},
                {title:'Clave de Prueba', rowspan:2},
                {title:'Prueba', rowSpan:2},
                {title:'Componentes Obtenidos Total Mensual', rowspan:2},
                {title:'Candidad de pruebas al día', colspan:1}
            ]],
			filename:"Reporte mensual de ST",

			date_hour:"",
			medical:"",
            start_date:'',
            end_date:''
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}

	}

	async componentDidMount(){
        var id = sessionStorage.getItem('health_facilities_id');

        let response = await clinicHistoryYearsHasHc(id);
        if(response){
            let options = response.map((res)=>{
                var obj = {
                    value: res,
                    text:res
                };

                return obj;
            });

            this.setState({years: options});
        }

		//await this.setTable();
	}


	handleChange(e){
		
		this.setState({
			[e.target.name]: e.target.value
		});

		if(document.getElementById(e.target.name).className.includes('error')){
			document.getElementById(e.target.name).classList.remove('error');
		}
	}

	searching(){

		if(this.isValidForm()){
			if(this.dateCompare()){
				var obj = {
					health_facilities_id: this.state.health_facilities_id,
					year: this.state.year,
                    end_month: this.state.init_month,
				}
				
                this.props.waiting.handleShow('Buscando...');
                fetch(Config.default.apiGateway.URL+'reports_imss/st_monthly_report',{
                    method: 'POST',
                    body:JSON.stringify(obj),
                    headers: new Headers({
                        'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
                        'Accept'		: 'application/json',
                        'Content-Type'	: 'application/json'
                    })
                }).then(res => {
                    this.props.waiting.handleClose();

                    if(res.ok){
                        return res.json();
                    }else{
                        res.text().then((msg)=>{
                            swal('Error', msg, 'error');
                        });
                    }
                }).then(async response => {
                    if(response !== undefined){
                        var list = [];
                        let columns = [[
                            {title:'No.', rowspan:2, width:'50px'},
                            {title:'Clave de Prueba', rowspan:2, width:'100px'},
                            {title:'Prueba', rowspan:2, width:'90px'},
                            {title:'Componentes Obtenidos Total Mensual', rowspan:2, width:'150px'},
                            {title:'Candidad de pruebas al día', colspan:30}
                        ]];
                        let setDay = false;
                        let days = [];
                        response.test.forEach((test, i)=>{
                            var obj = [
                                i+1,
                                test.key,
                                test.name,
                                test.total
                            ];

                            test.days.forEach((day)=>{
                                if(!setDay){
                                    days.push({title:day.day});
                                }

                                obj.push(day.total);
                                
                            });
                            setDay = true;

                            list.push(obj);
                        })

                        columns.push(days);
                        
                        console.log(columns, list)
                        this.setState({
                            data: list,
                            columns:columns,
                            start_date:moment(response.start_date).format('DD/MM/YYYY'),
                            end_date:moment(response.end_date).format('DD/MM/YYYY')
                        });

                    }
                });
               
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
			
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;
		if(this.state.search_type === 'date'){
			if(ini !== 'Invalid date' && fin !== 'Invalid date'){
				if(fin < ini){
					date_ok = false;
					document.getElementById('end_date').classList.add('error');
				}else{
					document.getElementById('end_date').classList.remove('error');
				}
			}else{
				date_ok = false;
			}		
		}
		
		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

    onPrint(type){
        var obj = {
            health_facilities_id: this.state.health_facilities_id,
            year: this.state.year,
            end_month: this.state.init_month,
        }

        if(type === 'excel'){
            this.props.printExcelReport(this.state.filename, 'st_monthly_report', obj);
        }else{
            this.props.printPdfIMSSReports('st_monthly_report', obj);
        }
    }

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					{this.state.filename}
					</h5>
				</div>
				<Help 
					{...this.props}
		            menu={"help_imss"} 
		            submenu={"help_st_monthly_report"}  />

				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>												
                                <div className="form-group">
                                    <LabelForm text="Años" />
                                    <SelectForm 
                                        id="year"
                                        value={this.state.year}
                                        options={this.state.years}
                                        handleChange={this.handleChange}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <LabelForm text="Mes" />
                                    <SelectForm 
                                        id="init_month"
                                        value={this.state.init_month}
                                        options={this.state.months}
                                        handleChange={this.handleChange}
                                        required
                                    />
                                </div>

							
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12">
									<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline",fontSize:'16px'}}>
										<span>
											{this.state.filename}
										</span>
									</div>
								</div>

                                <div className="col-xs-12 form-group" style={{textAlign:'right'}}>
									<button type="button" className="btn btn-default" disabled={this.state.data.length === 0} onClick={(e) => this.onPrint('excel')} style={{marginRight:8}}>Excel</button>
									<button type="button" className="btn btn-default" disabled={this.state.data.length === 0} onClick={(e) => this.onPrint('pdf')}>PDF</button>
								</div>
                                {this.state.data.length > 0 &&
                                    <div className='col-xs-12' style={{textAlign:'center'}}>
                                        <h5>{this.state.center}</h5>
                                        <p style={{textAlign:'center'}}>
                                            <b>Reporte Mensual de Sangre Total, componentes, pruebas pretransfusionales y pruebas de laboratorio efectivas realizadas</b><br/>
                                            <b>Información del {this.state.start_date} al {this.state.end_date} </b>
                                        </p>
                                    </div>
                                }

								<div className="col-xs-12 form-group" id="table-to-pdf">									
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className="table expenses-discards" id="table-to-xls" 
											 ref={el => this.el = el}>
                                            <thead>
                                                {this.state.columns.map((columns, i)=>
                                                    <tr key={i}>
                                                        {columns.map((col, j)=>
                                                            col.rowspan ?
                                                                <th key={j} style={{width:col.width}} rowSpan={col.rowspan}>{col.title}</th>
                                                            : col.colspan ? 
                                                                <th key={j} colSpan={col.colspan}>{col.title}</th>
                                                            :
                                                                <th key={j}>{col.title}</th>
                                                        )}
                                                    </tr>
                                                )}
                                            </thead>
                                            <tbody>
                                                {this.state.data.map((data, i)=>
                                                    <tr key={i}>
                                                        {data.map((d, j)=>
                                                            <td key={j}>{d}</td>
                                                        )}
                                                    </tr>
                                                )}
                                            </tbody>
										</table>
									</div>
									
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (STMonthly);